export const WEEKEND_DELIVERIES_CONFIGURATION_CACHE_KEY =
  'weekendDeliveryConfiguration'
